import { NgModule } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CmUiModule } from '@ats/cm/ui';
import { CmMiniButtonDirective } from '@cm/shared/ui/button';
import { CmTableCellComponent } from './components/table-cell/table-cell.component';
import { CmTableFilterComponent } from './components/table-filter/table-filter.component';
import { CmTableMetaComponent } from './components/table-meta/table-meta.component';
import { CmTableSearchComponent } from './components/table-search/table-search.component';
import { CmTableSelectedFilterComponent } from './components/table-selected-filter/table-selected-filter.component';
import { CmNewTableComponent } from './components/table/table.component';

const privateImports = [CmUiModule, CmMiniButtonDirective];

const publicImports = [MatTableModule, MatSortModule, MatPaginatorModule];

const publicDeclarations = [CmNewTableComponent];

const privateDeclarations = [
	CmTableCellComponent,
	CmTableFilterComponent,
	CmTableMetaComponent,
	CmTableSearchComponent,
	CmTableSelectedFilterComponent,
];

const declarations = [...publicDeclarations, ...privateDeclarations];

@NgModule({
	imports: [...publicImports, ...privateImports],
	declarations,
	exports: [...publicImports, ...declarations],
})
export class CmTableModule {}
